// media type array (TMP)
export const mediaTypes = [
	{
		id: 1,
		analysisType: 1,
		mediaType: 'video',
		label: 'Social media',
		icon: 'icon-some.svg',
		iconHighlight: 'icon-some-white.svg',
		info: 'Test your video ads made for social feeds and stories (e.g., Meta, TikTok, LinkedIn), typically optimized for mobile viewing.',
		vpos: 0
	},
	{
		id: 2,
		analysisType: 1,
		mediaType: 'video',
		label: 'Online video',
		icon: 'icon-olv.svg',
		iconHighlight: 'icon-olv-white.svg',
		info: 'Test your online video (OLV) made for placements like YouTube and web-sites (in-stream/ out-stream), not broadcast TV.',
		vpos: 0
	},
	{
		id: 3,
		analysisType: 1,
		mediaType: 'video',
		label: 'TVC',
		icon: 'icon-tvc.svg',
		iconHighlight: 'icon-tvc-white.svg',
		info: 'Test your TV com-mercial made to run in ad breaks (often 15-30 seconds).',
		vpos: 1,
		minRatio: 1.748 // 16:9 (1.77) minus allowed margin .022
	},
	{
		id: 4,
		analysisType: 1,
		mediaType: 'video',
		label: 'Cinema',
		icon: 'icon-cinema.svg',
		iconHighlight: 'icon-cinema-white.svg',
		info: 'Test your cinema spot designed for the big screen.',
		vpos: 3,
		minRatio: 1.748 // 16:9 (1.77) minus allowed margin .022
	},
	{
		id: 5,
		analysisType: 1,
		mediaType: 'video',
		label: 'Adshell/billboard',
		icon: 'icon-adshell.svg',
		iconHighlight: 'icon-adshell-white.svg',
		info: 'Test your video out-of-home ads shown on roadside or street displays, designed for quick, distant viewing.',
		vpos: 1
	},
	{
		id: 6,
		analysisType: 2,
		mediaType: 'video',
		label: 'Animatic',
		icon: 'icon-animatic.svg',
		iconHighlight: 'icon-animatic-white.svg',
		info: 'Test your rough pre-production story-board video used to test the concept before final pro-duction.',
		vpos: -4
	},
	{
		id: 7,
		analysisType: 3,
		mediaType: 'image',
		label: 'Social media',
		icon: 'icon-some-img.svg',
		iconHighlight: 'icon-some-img-white.svg',
		info: 'Test your static ads made for social feeds and stories (e.g., Meta, TikTok, LinkedIn), typically optimized for mobile viewing.',
		vpos: 0
	},
	{
		id: 8,
		analysisType: 3,
		mediaType: 'image',
		label: 'Print ad',
		icon: 'icon-print.svg',
		iconHighlight: 'icon-print-white.svg',
		info: 'Test your static ads intended for print in magazines, news-papers, flyers, or brochures.',
		vpos: -1
	},
	{
		id: 9,
		analysisType: 3,
		mediaType: 'image',
		label: 'Poster/Signage',
		icon: 'icon-poster-signage.svg',
		iconHighlight: 'icon-poster-signage-white.svg',
		info: 'Test your static posters or signage designs viewed at close to mid distance (e.g., in-store or events).',
		vpos: 1
	},
	{
		id: 10,
		analysisType: 3,
		mediaType: 'image',
		label: 'Adshell/billboard',
		icon: 'icon-adshell-still.svg',
		iconHighlight: 'icon-adshell-still-white.svg',
		info: 'Test your static out-of-home ads shown on roadside or street displays, designed for quick, distant viewing.',
		vpos: 1
	}
]

// get media type by id
export function getMediaTypeById(id) {
	return mediaTypes.find(type => type.id === id)
}